  import React, { useState, useEffect } from "react";
  import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useLocation,
  } from "react-router-dom";
  import ReactGA from 'react-ga4'; 
  import { HelmetProvider } from 'react-helmet-async';

  import AuthManager from "./component/signup/AuthManager";
  import LoaderContext from "./context/LoaderContext";
  import GlobalLoader from "./component/GlobalLoader";
  import ScrollToTop from "./component/about/ScrollToTop";
  import Home from "./component/home/Home";
  import Profile from "./component/header/profile";
  import Signup from "./component/signup/signup";
  import ThankYouPage from "./component/astrologerverification/ThankYouPage";
  import ThankYou from "./component/astrologerverification/Thanku";
  import Document from "./component/astrologerverification/document";
  import Bank from "./component/astrologerverification/bank";
  import Blog from "./component/blog/Blog";
  import Blog1 from "./component/blog/Blog1";
  import BlogList from "./component/blog/BlogList";
  import BlogDetail from "./component/blog/BlogDetail";
  import YearlyHoroscope from "./component/yearlyhoroscope/Yearlyhoroscope";
  import SagittariusYearly from "./component/yearlyhoroscope/Sagittariusyearly";
  import AriesYearly from "./component/yearlyhoroscope/Ariesyearly";
  import TaurasYearly from "./component/yearlyhoroscope/Taurasyearly";
  import CancerYearly from "./component/yearlyhoroscope/Canceryearly";
  import Leoyearly from "./component/yearlyhoroscope/Leoyearly";
  import Virgoyearly from "./component/yearlyhoroscope/Virgoyearly";
  import Librayearly from "./component/yearlyhoroscope/Librayearly";
  import Scorpioyearly from "./component/yearlyhoroscope/Scorpioyearly";
  import Capricornyearly from "./component/yearlyhoroscope/Capricornyearly";
  import Aquariusyearly from "./component/yearlyhoroscope/Aquariusyearly";
  import Piscesyearly from "./component/yearlyhoroscope/Piscesyearly";
  import Geminiyearly from "./component/yearlyhoroscope/Geminiyearly";
  import Header from "./component/header/header";
  import Footer from "./component/footer/footer";
  import DailyHoroscope from "./component/horoscope/dailyhoroscope";
  import Horoscope from "./component/horoscope/horoscope";
  import Aries from "./component/horoscope/Aries";
  import Taurus from "./component/horoscope/Taurus";
  import Gemini from "./component/horoscope/Gemini";
  import Cancer from "./component/horoscope/Cancer";
  import Leo from "./component/horoscope/Leo";
  import Libra from "./component/horoscope/Libra";
  import Scorpio from "./component/horoscope/Scorpio";
  import Sagittarius from "./component/horoscope/Sagittarius";
  import Aquarius from "./component/horoscope/Aquarius";
  import Capricorn from "./component/horoscope/Capricorn";
  import Pisces from "./component/horoscope/Pisces";
  import Virgo from "./component/horoscope/Virgo";
  import Call from "./component/call-chat/Call";
  import Astroverify from "./component/call-chat/astroverify";
  import Chat from "./component/call-chat/Chat";
  import Intake from "./component/call-chat/Intake";
  import PrivacyPolicy from "./component/privacypolicy/Privacypolicy";
  import Refund from "./component/privacypolicy/Refund";
  import Termsandconditions from "./component/privacypolicy/termsandconditions";
  import Faq from "./component/faq/faq";
  import About from "./component/about/about";
  import AstrologerRegistration from "./component/astrologerregistration/astrologerresgistration";
  import Astrologerform from "./component/astrologerregistration/astrologerresgistration";
  import Otpvalidation from "./component/otpvalidation/otpvalidation";
  import CustomerRegistrationForm from "./component/userregistration/CustomerRegistrationForm";
  import Festivals from "./component/Festivals/festival";
  import Astrochat from "./component/call-chat/astrochat";
  import Banner from "./component/home/banner";
  import Baner from "./component/home/baner";
  import Callbanner from "./component/home/callbanner";
  import Banneer from "./component/home/banneer";
  import UserSelectionPage from "./component/signup/UserSelectionPage";
  import Deshboard from "./component/adminpanel/deshboard";
  import Pending from "./component/adminpanel/PendingRegistrations";
  import Rejected from "./component/adminpanel/RejectedApplications";
  import Reports from "./component/adminpanel/ReportsAnalytics";
  import Login from "./component/adminpanel/Login";
  import ViewAstrologerApplication from "./component/adminpanel/ViewAstrologerApplication";
  import Bestastrologer from "./component/bestastrologer/bestastrologer";
  import BlogUpload from "./component/adminpanel/blogupload";
  import HoroscopeUpload from "./component/adminpanel/horoscopeupload";
  import FaqManager from "./component/adminpanel/faqmanager";
  import DeleteAccountPopup from "./component/footer/DeleteAccountPopup";
  import AstrologyWalletPayment from "./component/header/AstrologyWalletPayment";
  import InquiryForm from "./component/call-chat/inquiryform";
  import WebChatScreen from "./component/call-chat/webchatscreen";
  import Feedback from "./component/call-chat/feedback";
  import { Toaster } from 'react-hot-toast';
  import AppDownloadOverlay from "./component/astrologerverification/AppDownloadOverlay";
  import UnifiedOtpValidate from "./component/otpvalidation/UnifiedOtpValidate";
  import RegisterUserSelection from "./component/signup/RegisterUserSelection";
  import Wallet from "./component/header/Wallet";
  import MySessionsPage from "./component/header/MySessions";
  import HelpSupportPage from "./component/header/HelpSupportPage";
  import MyFollowingPage from "./component/header/MyFollowing";

  const GA_MEASUREMENT_ID = "G-22BSN8DQNZ";
  ReactGA.initialize(GA_MEASUREMENT_ID);


  function GAPageTracker() {
    const location = useLocation(); 

    useEffect(() => {
    
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    

      if (window.fbq) {
        window.fbq('track', 'PageView');
      }

      console.log("GA4 Pageview tracked:", location.pathname + location.search);
    }, [location]); 

    return null; 
  }

  export default function App() {
    const [loading, setLoading] = useState(false);

    return (
      <HelmetProvider>
      <LoaderContext.Provider value={{ loading, setLoading }}>
        <Router>
          <AuthManager />
          <AppDownloadOverlay />
          {/* <Toaster position="top-center" reverseOrder={false} /> */}
          <Toaster 
    position="top-center" 
    reverseOrder={false} 
    containerStyle={{
      zIndex: 9999999, // Modal se ek digit zyada rakho
    }}
  />
          <GAPageTracker />
          <GlobalLoader />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="profile" element={<Profile />} />
            <Route path="signup" element={<Signup />} />
            <Route path="app-downloads" element={<ThankYouPage />} />
            <Route path="app-download" element={<ThankYou />} />
            <Route path="document" element={<Document />} />
            <Route path="bank-details" element={<Bank />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Blog1 />} />
            <Route path="blogs" element={<BlogList />} />
            <Route path="blogs/:slug" element={<BlogDetail />} />
            <Route path="header" element={<Header />} />
            <Route path="footer" element={<Footer />} />
            <Route path="horoscope" element={<Horoscope />} />
            <Route
              path="/daily-horoscope/:day/:sign"
              element={<DailyHoroscope />}
            />
            <Route
              path="/daily-horoscope"
              element={<Navigate to="/daily-horoscope/today/aries" />}
            />
            <Route
              path="/daily-horoscopeari"
              element={<Navigate to="/daily-horoscope/today/aries" />}
            />
            <Route
              path="/daily-horoscopetau"
              element={<Navigate to="/daily-horoscope/today/taurus" />}
            />
            <Route
              path="/daily-horoscopegem"
              element={<Navigate to="/daily-horoscope/today/gemini" />}
            />
            <Route
              path="/daily-horoscopetau"
              element={<Navigate to="/daily-horoscope/today/taurus" />}
            />
            <Route
              path="/daily-horoscopegem"
              element={<Navigate to="/daily-horoscope/today/gemini" />}
            />
            <Route
              path="/daily-horoscopecan"
              element={<Navigate to="/daily-horoscope/today/cancer" />}
            />
            <Route
              path="/daily-horoscopecap"
              element={<Navigate to="/daily-horoscope/today/capricorn" />}
            />
            <Route
              path="/daily-horoscopeleo"
              element={<Navigate to="/daily-horoscope/today/leo" />}
            />
            <Route
              path="/daily-horoscopelib"
              element={<Navigate to="/daily-horoscope/today/libra" />}
            />
            <Route
              path="/daily-horoscopepis"
              element={<Navigate to="/daily-horoscope/today/pisces" />}
            />
            <Route
              path="/daily-horoscopesco"
              element={<Navigate to="/daily-horoscope/today/scorpio" />}
            />
            <Route
              path="/daily-horoscopesag"
              element={<Navigate to="/daily-horoscope/today/sagittarius" />}
            />
            <Route
              path="/daily-horoscopevir"
              element={<Navigate to="/daily-horoscope/today/virgo" />}
            />
            <Route
              path="/daily-horoscopeaqa"
              element={<Navigate to="/daily-horoscope/today/aquarius" />}
            />

            <Route path="/daily-horoscope/:day/:sign" element={<Aries />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Taurus />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Gemini />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Cancer />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Leo />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Libra />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Scorpio />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Sagittarius />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Aquarius />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Capricorn />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Pisces />} />
            <Route path="/daily-horoscope/:day/:sign" element={<Virgo />} />

            <Route path="yearly-horoscope" element={<YearlyHoroscope />} />
            <Route
              path="yearly-horoscope/sagittarius"
              element={<SagittariusYearly />}
            />
            <Route path="yearly-horoscope/aries" element={<AriesYearly />} />
            <Route path="yearly-horoscope/taurus" element={<TaurasYearly />} />
            <Route path="yearly-horoscope/cancer" element={<CancerYearly />} />
            <Route path="yearly-horoscope/leo" element={<Leoyearly />} />
            <Route path="yearly-horoscope/virgo" element={<Virgoyearly />} />
            <Route path="yearly-horoscope/libra" element={<Librayearly />} />
            <Route path="yearly-horoscope/scorpio" element={<Scorpioyearly />} />
            <Route
              path="yearly-horoscope/capricorn"
              element={<Capricornyearly />}
            />
            <Route
              path="yearly-horoscope/aquarius"
              element={<Aquariusyearly />}
            />
            <Route path="yearly-horoscope/pisces" element={<Piscesyearly />} />
            <Route path="yearly-horoscope/gemini" element={<Geminiyearly />} />

            <Route path="call-with-astrologer" element={<Call />} />
            <Route path="chat-with-astrologer" element={<Chat />} />

            <Route path="/inquary/:astrologerId" element={<InquiryForm />} />
  <Route path="/chat/:sessionId" element={<WebChatScreen />} />
  <Route path="/feedback/:sessionId" element={<Feedback />} />

            <Route path="astroverify" element={<Astroverify />} />
            <Route path="intake" element={<Intake />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="faq" element={<Faq />} />
            <Route path="about" element={<About />} />
            <Route
              path="astrologer-registration"
              element={<AstrologerRegistration />}
            />
            <Route path="otp-verifications" element={<Otpvalidation />} />


  {/* register otp verify */}
            {/* <Route path="signup-otp-verifications" element={<UnifiedOtpValidate />} /> */}

            
            <Route path="astrologerform" element={<Astrologerform />} />
            <Route
              path="user-registration"
              element={<CustomerRegistrationForm />}
            />
            <Route path="festival/:month?" element={<Festivals />} />
            <Route path="astrochat" element={<Astrochat />} />
            <Route path="banner" element={<Banner />} />
            <Route path="baner" element={<Baner />} />
            <Route path="banneer" element={<Banneer />} />
            <Route path="callbanner" element={<Callbanner />} />
            <Route path="terms-and-conditions" element={<Termsandconditions />} />


            <Route path="who-are-you" element={<UserSelectionPage />} />

            {/* signup-whoareyou */}
            <Route path="signup-who-are-you" element={<RegisterUserSelection />} />
            <Route path="refund-policy" element={<Refund />} />
            <Route path="Login" element={<Login />} />
            <Route path="ReportsAnalytics" element={<Reports />} />
            <Route path="RejectedApplications" element={<Rejected />} />
            <Route path="Pending" element={<Pending />} />
            <Route path="/deshboard" element={<Deshboard />} />
          
            <Route path="blogupload" element={<BlogUpload />} />
            <Route path="horoscopeupload" element={<HoroscopeUpload/>} />
            <Route
              path="admin/view/:id"
              element={<ViewAstrologerApplication />}
            />
            <Route path="bestastrologer" element={<Bestastrologer />} />
            <Route path="faqmanager" element={<FaqManager />} />
            <Route path="account-deletion" element={<DeleteAccountPopup />} />
            <Route path="wallet" element={<Wallet />} />
            <Route path="my-sessions" element={<MySessionsPage />} />
            <Route path="my-following" element={<MyFollowingPage />} />
            <Route path="help-and-support" element={<HelpSupportPage />} />
            <Route path="wallet_payment" element={<AstrologyWalletPayment />} />


          
          </Routes>
        </Router>
      </LoaderContext.Provider>
      </HelmetProvider>
    );
  }
